<mat-card class="ddc-content-card" [class.ddc-content-card-dictionary-card]="dictionary() !== undefined">
  <!-- Header -->
  <div class="ddc-content-card-header">
    <div class="ddc-content-card-header-left">
      <!-- Language flag for mobile -->
      @if (word() !== undefined) {
        <div class="ddc-content-lng-mobile">
          <ddc-profile-pic
            [category]="word().category?.label"
            [contentType]="'word'"
            [creationTime]="word().time_since_creation"
            [dictionaries]="word().dictionaries"
            [dynamicRoute]="'/users/' + word().owner?.username"
            [followerCount]="word().owner?.followers_count"
            [language_1]="word().language"
            [privacy]="word().privacy"
            [subscription]="word().owner?.subscription"
            [username]="word().owner?.username"
            [userProfilePic]="word().owner?.profile_pic"
            [verified]="word().owner?.verified"
          ></ddc-profile-pic>
        </div>
      } @else if (pair() !== undefined) {
        <div class="ddc-content-lngs-mobile">
          <ddc-profile-pic
            [category]="pair().word_1.category?.label"
            [contentType]="'pair'"
            [creationTime]="pair().time_since_creation"
            [dictionaries]="pair().dictionaries"
            [dynamicRoute]="'/users/' + pair().owner?.username"
            [followerCount]="pair().owner?.followers_count"
            [language_1]="pair().word_1.language"
            [language_2]="pair().word_2.language"
            [privacy]="pair().word_1.privacy"
            [subscription]="pair().owner?.subscription"
            [username]="pair().owner?.username"
            [userProfilePic]="pair().owner?.profile_pic"
            [verified]="pair().owner?.verified"
          ></ddc-profile-pic>
        </div>
      } @else if (dictionary() !== undefined) {
        <div class="ddc-content-lngs-mobile">
          <ddc-profile-pic
            [contentType]="'dictionary'"
            [creationTime]="dictionary().time_since_creation"
            [dic_pairs]="dictionary().pairs_count"
            [dic_words]="dictionary().words_count"
            [dynamicRoute]="'/users/' + dictionary().owner?.username"
            [followerCount]="dictionary().owner?.followers_count"
            [subscription]="dictionary().owner?.subscription"
            [username]="dictionary().owner?.username"
            [userProfilePic]="dictionary().owner?.profile_pic"
            [verified]="dictionary().owner?.verified"
          ></ddc-profile-pic>
        </div>
      } @else if (note() !== undefined) {
        <div class="ddc-content-lngs-mobile">
          <ddc-profile-pic
            [contentType]="'note'"
            [creationTime]="note().time_since_creation"
            [dynamicRoute]="'/users/' + note().owner?.username"
            [followerCount]="note().owner?.followers_count"
            [subscription]="note().owner?.subscription"
            [username]="note().owner?.username"
            [userProfilePic]="note().owner?.profile_pic"
            [verified]="note().owner?.verified"
          ></ddc-profile-pic>
        </div>
      } @else if (quiz() !== undefined) {
        <div class="ddc-content-lngs-mobile">
          <ddc-profile-pic
            [contentType]="'quiz'"
            [creationTime]="quiz().time_since_creation"
            [dynamicRoute]="'/users/' + quiz().owner?.username"
            [followerCount]="quiz().owner?.followers_count"
            [subscription]="quiz().owner?.subscription"
            [username]="quiz().owner?.username"
            [userProfilePic]="quiz().owner?.profile_pic"
            [verified]="quiz().owner?.verified"
          ></ddc-profile-pic>
        </div>
      } @else if (figure() !== undefined) {
        <div class="ddc-content-lngs-mobile">
          <ddc-profile-pic
            [contentType]="'figure'"
            [creationTime]="figure().time_since_creation"
            [dynamicRoute]="'/users/' + figure().owner?.username"
            [followerCount]="figure().owner?.followers_count"
            [subscription]="figure().owner?.subscription"
            [username]="figure().owner?.username"
            [userProfilePic]="figure().owner?.profile_pic"
            [verified]="figure().owner?.verified"
          ></ddc-profile-pic>
        </div>
      }
    </div>

    <div class="ddc-content-card-header-middle"></div>

    <div class="ddc-content-card-header-right">
      @if (word() !== undefined) {
        <ddc-three-dots
          mode="lib_word_1"
          [isMine]="isMine()"
          (openWordDeleteDialog)="cardDeleteClick()"
          (openWordDialog)="cardClick()"
          (openWordEditDialog)="cardEditClick()"
        ></ddc-three-dots>
      }
      @if (pair() !== undefined) {
        <ddc-three-dots
          mode="lib_pair_1"
          [isMine]="isMine()"
          (openPairDeleteDialog)="cardDeleteClick()"
          (openPairDialog)="cardClick()"
          (openPairEditDialog)="cardEditClick()"
        ></ddc-three-dots>
      }
      @if (dictionary() !== undefined) {
        <ddc-three-dots
          mode="lib_dic_1"
          [isMine]="isMine()"
          (openDicDeleteDialog)="cardDeleteClick()"
          (openDicDialog)="cardClick()"
        ></ddc-three-dots>
      }
      @if (note() !== undefined) {
        <!-- <ddc-three-dots
          mode="lib_dic_1"
          [isMine]="isMine()"
          (openDicDeleteDialog)="cardDeleteClick()"
          (openDicDialog)="cardClick()"
        ></ddc-three-dots> -->
      }
      @if (quiz() !== undefined) {
        <!-- <ddc-three-dots
          mode="lib_dic_1"
          [isMine]="isMine()"
          (openDicDeleteDialog)="cardDeleteClick()"
          (openDicDialog)="cardClick()"
        ></ddc-three-dots> -->
      }
      @if (figure() !== undefined) {
        <!-- <ddc-three-dots
          mode="lib_dic_1"
          [isMine]="isMine()"
          (openDicDeleteDialog)="cardDeleteClick()"
          (openDicDialog)="cardClick()"
        ></ddc-three-dots> -->
      }
    </div>
  </div>

  <!-- Main Content -->
  <div
    class="ddc-content-card-main"
    [class.ddc-content-card-main-clickable]="!!dynamicRoute()"
    [routerLink]="dynamicRoute() !== undefined ? [dynamicRoute()] : null"
    (click)="cardClick()"
  >
    <div class="ddc-content-card-main-2">
      @if (word() !== undefined) {
        <div class="ddc-content-card-main-2-main">
          <div class="ddc-content-main-content">
            <ng-container *ngIf="word().article">
              <div class="ddc-content-art" matTooltip="Article">
                {{ word().article }}
              </div>
            </ng-container>
            <div class="ddc-content-word" [matTooltip]="'Word'">{{ word().word }}</div>

            <ng-container *ngIf="word().pos">
              <div class="ddc-content-pos" matTooltip="Part of Speech">[{{ word().pos }}]</div>
            </ng-container>
          </div>
        </div>

        <!-- Definition and Example -->
        <div class="ddc-word-content" [class.expanded]="showDefinition() || showExample()">
          <!-- Definition -->
          <div class="ddc-content-section" *ngIf="word().definition && showDefinition()">
            <div class="ddc-content-label">
              <mat-icon class="ddc-content-icon">description</mat-icon>
              <span>Definition</span>
            </div>
            <div class="ddc-content-text">
              <span [innerHTML]="word().definition | highlightWord: word().word"></span>
            </div>
          </div>
          <!-- Example -->
          <div class="ddc-content-section" *ngIf="word().example && showExample()">
            <div class="ddc-content-label">
              <mat-icon class="ddc-content-icon">format_quote</mat-icon>
              <span>Example</span>
            </div>
            <div class="ddc-content-text">
              <span [innerHTML]="word().example | highlightWord: word().word"></span>
            </div>
          </div>
        </div>
      }

      @if (pair() !== undefined) {
        <div class="ddc-content-card-main-2-main">
          <div class="ddc-content-main-content">
            <ng-container *ngIf="pair().word_1.article">
              <div class="ddc-content-art" matTooltip="Article">
                {{ pair().word_1.article }}
              </div>
            </ng-container>
            <div class="ddc-content-word" [matTooltip]="'Word'">{{ pair().word_1.word }}</div>

            <ng-container *ngIf="pair().word_1.pos">
              <div class="ddc-content-pos" matTooltip="Part of Speech">[{{ pair().word_1.pos }}]</div>
            </ng-container>
          </div>
          <div class="ddc-content-main-content">
            <ng-container *ngIf="pair().word_2.article">
              <div class="ddc-content-art" matTooltip="Article">
                {{ pair().word_2.article }}
              </div>
            </ng-container>
            <div class="ddc-content-word" [matTooltip]="'Word'">{{ pair().word_2.word }}</div>

            <ng-container *ngIf="pair().word_2.pos">
              <div class="ddc-content-pos" matTooltip="Part of Speech">[{{ pair().word_2.pos }}]</div>
            </ng-container>
          </div>
        </div>

        <!-- Definition and Example -->
        <div class="ddc-word-content" [class.expanded]="showDefinition() || showExample()">
          <!-- Definition -->
          <div
            class="ddc-content-section"
            *ngIf="(pair().word_1.definition || pair().word_2.definition) && showDefinition()"
          >
            <div class="ddc-content-label">
              <mat-icon class="ddc-content-icon">description</mat-icon>
              <span>Definitions</span>
            </div>
            <div
              class="ddc-content-text"
              *ngIf="pair().word_1.definition"
              [innerHTML]="pair().word_1.definition | highlightWord: pair().word_1.word"
            ></div>
            <mat-divider
              *ngIf="pair().word_2.definition && pair().word_1.definition"
              style="margin: 8px 0"
            ></mat-divider>
            <div
              class="ddc-content-text"
              *ngIf="pair().word_2.definition"
              [innerHTML]="pair().word_2.definition | highlightWord: pair().word_2.word"
            ></div>
          </div>
          <!-- Example -->
          <div class="ddc-content-section" *ngIf="(pair().word_2.example || pair().word_2.example) && showExample()">
            <div class="ddc-content-label">
              <mat-icon class="ddc-content-icon">format_quote</mat-icon>
              <span>Examples</span>
            </div>
            <div
              class="ddc-content-text"
              *ngIf="pair().word_1.example"
              [innerHTML]="pair().word_1.example | highlightWord: pair().word_1.word"
            ></div>
            <mat-divider *ngIf="pair().word_2.example && pair().word_1.example" style="margin: 8px 0"></mat-divider>
            <div
              class="ddc-content-text"
              *ngIf="pair().word_2.example"
              [innerHTML]="pair().word_2.example | highlightWord: pair().word_2.word"
            ></div>
          </div>
        </div>
      }

      @if (dictionary() !== undefined) {
        <div class="ddc-content-card-main-2-main">
          <div class="ddc-content-main-content">
            <div class="ddc-content-word" [matTooltip]="'Title'">{{ dictionary().title }}</div>
          </div>
          @if (dictionary() !== undefined) {
            <div class="ddc-content-card-header-right-dic-counts">
              <ddc-element-count
                class="dic-counts-elem"
                matTooltip="Words"
                [count]="dictionary().words_count.toString()"
                [icon]="'fiber_manual_record'"
                [size]="'small'"
              ></ddc-element-count>
              <ddc-element-count
                class="dic-counts-elem"
                matTooltip="Pairs"
                [count]="dictionary().pairs_count.toString()"
                [icon]="'fiber_smart_record'"
                [size]="'small'"
              ></ddc-element-count>
            </div>
          }
        </div>

        <!-- Description -->
        <div class="ddc-word-content" [class.expanded]="showDescription()">
          <div class="ddc-content-section" *ngIf="dictionary().description && showDescription()">
            <div class="ddc-content-label">
              <mat-icon class="ddc-content-icon">description</mat-icon>
              <span>Description</span>
            </div>
            <div class="ddc-content-text">
              <span [innerHTML]="dictionary().description | highlightWord: dictionary().title"></span>
            </div>
          </div>
        </div>
      }

      @if (note() !== undefined) {
        <div class="ddc-content-card-main-2-main">
          <div class="ddc-content-main-content">
            <div class="ddc-content-word" [matTooltip]="'Title'">{{ note().title }}</div>
          </div>

          <!-- Text (expandable) -->
          <div class="ddc-word-content" [class.expanded]="showDescription()">
            <div class="ddc-content-section" *ngIf="note().text && showDescription()">
              <div class="ddc-content-label">
                <mat-icon class="ddc-content-icon">text_snippet</mat-icon>
                <span>Text</span>
              </div>
              <div class="ddc-content-text">
                <span [innerHTML]="note().text | highlightWord: note().title"></span>
              </div>
            </div>
          </div>
        </div>
      }

      @if (quiz() !== undefined) {
        <div class="ddc-content-card-main-2-main">
          <div class="ddc-content-main-content">
            <div class="ddc-content-word" [matTooltip]="'Title'">{{ quiz().title }}</div>
          </div>

          <!-- Description (expandable) -->
          <div class="ddc-word-content" [class.expanded]="showDescription()">
            <div class="ddc-content-section" *ngIf="quiz().description && showDescription()">
              <div class="ddc-content-label">
                <mat-icon class="ddc-content-icon">description</mat-icon>
                <span>Description</span>
              </div>
              <div class="ddc-content-text">
                <span [innerHTML]="quiz().description | highlightWord: quiz().title"></span>
              </div>
            </div>
          </div>
        </div>
      }

      @if (figure() !== undefined) {
        <div class="ddc-content-card-main-2-main">
          <div class="ddc-content-main-content">
            <div class="ddc-content-word" [matTooltip]="'Title'">{{ figure().title }}</div>
          </div>
        </div>

        <!-- Figure image -->
        <div class="ddc-figure-card-image" *ngIf="figure().figure_pic">
          <img class="figure-card-img" [alt]="figure().title" [src]="getFigurePicUrl(figure().figure_pic)" />
        </div>

        <!-- Description (expandable) -->
        <div class="ddc-word-content" [class.expanded]="showDescription()">
          <div class="ddc-content-section" *ngIf="figure().description && showDescription()">
            <div class="ddc-content-label">
              <mat-icon class="ddc-content-icon">description</mat-icon>
              <span>Description</span>
            </div>
            <div class="ddc-content-text">
              <span [innerHTML]="figure().description | highlightWord: figure().title"></span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Footer -->
  <div class="ddc-content-card-footer">
    <div class="ddc-content-card-footer-left">
      <ddc-like
        [content_type_id]="contentTypeID()"
        [count]="content().likes"
        [is_liked]="content().is_liked"
        [obj_id]="content().id"
      ></ddc-like>
      @if (dictionary() !== undefined) {
        <!-- <ddc-ai-generated-label class="dic-ai-generated-btn" *ngIf="dictionary().ai_generated"></ddc-ai-generated-label> -->
      }
    </div>

    <div class="ddc-content-card-footer-right">
      <!-- Toggle Definition/Example -->
      @if (word() !== undefined) {
        <ddc-expand-btn
          *ngIf="word().definition || word().example"
          [disabled]="false"
          [expanded]="showDefinition() || showExample()"
          [tooltip]="'definition and example'"
          (expandedChange)="toggleContent()"
        ></ddc-expand-btn>
        @if (isMine()) {
          <ddc-lingo-function [tooltip]="'Improve with Lingo AI'" (click)="showUpgradeDialog()"></ddc-lingo-function>
        }
      }

      @if (pair() !== undefined) {
        <ddc-expand-btn
          *ngIf="pair().word_1.definition || pair().word_2.definition || pair().word_1.example || pair().word_2.example"
          [disabled]="false"
          [expanded]="showDefinition() || showExample()"
          [tooltip]="'definitions and examples'"
          (expandedChange)="toggleContent()"
        ></ddc-expand-btn>
        @if (isMine()) {
          <ddc-lingo-function [tooltip]="'Improve with Lingo AI'" (click)="showUpgradeDialog()"></ddc-lingo-function>
        }
      }

      @if (dictionary() !== undefined) {
        <ddc-expand-btn
          *ngIf="dictionary().description"
          [disabled]="false"
          [expanded]="showDescription()"
          [tooltip]="'description'"
          (expandedChange)="toggleContent()"
        ></ddc-expand-btn>
        <ddc-icon-function
          [icon]="'print'"
          [tooltip]="'Export to PDF'"
          (click)="showGeneratePdfDialog()"
        ></ddc-icon-function>
        <ddc-icon-function
          [icon]="'sports_esports'"
          [tooltip]="'Games'"
          (click)="showUpgradeDialog()"
        ></ddc-icon-function>
        <ddc-icon-function
          [icon]="'style'"
          [tooltip]="'Flash Cards'"
          (click)="routeToFlashCardsModePage()"
        ></ddc-icon-function>
      }

      @if (note() !== undefined) {
        <ddc-expand-btn
          *ngIf="note().text"
          [disabled]="false"
          [expanded]="showDescription()"
          [tooltip]="'text'"
          (expandedChange)="toggleContent()"
        ></ddc-expand-btn>
        @if (isMine()) {
          <ddc-lingo-function [tooltip]="'Improve with Lingo AI'" (click)="showUpgradeDialog()"></ddc-lingo-function>
        }
      }

      @if (quiz() !== undefined) {
        <ddc-expand-btn
          *ngIf="quiz().description"
          [disabled]="false"
          [expanded]="showDescription()"
          [tooltip]="'description'"
          (expandedChange)="toggleContent()"
        ></ddc-expand-btn>
      }

      @if (figure() !== undefined) {
        <ddc-expand-btn
          *ngIf="figure().description"
          [disabled]="false"
          [expanded]="showDescription()"
          [tooltip]="'description'"
          (expandedChange)="toggleContent()"
        ></ddc-expand-btn>
      }

      <!-- Bookmark -->
      <ddc-bookmark
        [content_type_id]="contentTypeID()"
        [count]="content().bookmarks"
        [is_bookmarked]="content().is_bookmarked"
        [obj_id]="content().id"
        (bookmarkChanged)="handleBookmarkChanged($event)"
      ></ddc-bookmark>
    </div>
  </div>
</mat-card>
